<script setup lang="ts">
export type IconFields = {
  icon?: {
    fields: {
      file: {
        contentType: 'image/svg+xml'
        details: {
          image: {
            height: number
            width: number
          }
        }
        url: string
      }
    }
  }
  altText?: string
}

export type IconProps = {
  fields?: IconFields
  loading?: 'lazy' | 'eager' | undefined
  alt?: string
}

const props = withDefaults(defineProps<IconProps>(), { loading: 'lazy' })
const alt = props?.fields?.altText || props?.alt
const file = props?.fields?.icon?.fields?.file
const src = file?.url
const height = file?.details?.image?.height
const width = file?.details?.image?.width
</script>

<template>
  <div class="icon">
    <img
      class="icon__img"
      data-testid="icon__img"
      :src="src"
      :width="width"
      :height="height"
      :alt="alt"
      :loading="loading"
      :style="height ? { '--icon-height': `${height}px` } : undefined"
    />
  </div>
</template>

<style lang="postcss">
.icon {
  display: inline-block;
  .icon__img {
    width: auto;
  }
}
</style>
